<template>
  <main-footer />
</template>

<script>
import MainFooter from '@/layouts/Footer.vue'

export default {
  name: 'MobileFooter',
  components: { MainFooter }
}
</script>
